export const categoryMovies: Record<string, {
  id: number;
  title: string;
  year: number;
  category: string;
  rating: number;
  region: string;
  imageUrl: string;
  tags?: string[];
  description?: string;
}[]> = {
  movie: [
    {
      id: 101, title: "流浪地球3", year: 2026, category: "科幻 / 冒险", rating: 9.2, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20science%20fiction%20movie%20poster%20with%20futuristic%20space%20station%2C%20warm%20orange%20lighting%2C%20cinematic%20style%2C%20dramatic%20atmosphere%2C%20movie%20poster%20design%2C%20clean%20background&width=600&height=800&seq=cat-movie-101&orientation=portrait",
      tags: ["热门", "高分"], description: "中国科幻史诗巨制，人类面临太阳危机，联合政府决定实施「流浪地球」计划，带着地球去流浪。",
    },
    {
      id: 102, title: "封神第二部", year: 2026, category: "奇幻 / 动作", rating: 8.9, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%2C%20golden%20and%20red%20tones%2C%20cinematic%20style%2C%20dramatic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-102&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 103, title: "哪吒之魔童闹海", year: 2025, category: "动画 / 奇幻", rating: 9.5, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20mythological%20hero%20character%2C%20vibrant%20red%20tones%2C%20dynamic%20pose%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20background&width=600&height=800&seq=cat-movie-103&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 104, title: "奥本海默", year: 2023, category: "剧情 / 传记", rating: 8.8, region: "美国",
      imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20biographical%20film%20poster%20with%20intense%20portrait%20and%20atomic%20motif%2C%20dark%20and%20warm%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-104&orientation=portrait",
      tags: ["高分", "经典"],
    },
    {
      id: 105, title: "孤注一掷", year: 2025, category: "犯罪 / 剧情", rating: 8.6, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20film%20poster%20with%20tense%20atmosphere%2C%20urban%20night%20setting%2C%20red%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-105&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 106, title: "碟中谍8", year: 2025, category: "动作 / 冒险", rating: 8.4, region: "美国",
      imageUrl: "https://readdy.ai/api/search-image?query=Hollywood%20action%20spy%20film%20poster%20with%20dynamic%20stunt%20scene%2C%20urban%20setting%2C%20warm%20golden%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-106&orientation=portrait",
      tags: ["新片"],
    },
    {
      id: 107, title: "沙丘2", year: 2025, category: "科幻 / 冒险", rating: 8.7, region: "美国",
      imageUrl: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20film%20poster%20with%20desert%20landscape%20and%20massive%20sandworms%2C%20warm%20golden%20and%20orange%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-107&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 108, title: "热辣滚烫", year: 2025, category: "喜剧 / 剧情", rating: 8.2, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%20with%20warm%20uplifting%20atmosphere%2C%20bright%20lighting%2C%20cinematic%20style%2C%20movie%20poster%20design%2C%20clean%20composition%2C%20joyful%20tone&width=600&height=800&seq=cat-movie-108&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 109, title: "熊出没·逆转时空", year: 2025, category: "动画 / 喜剧", rating: 8.1, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20film%20poster%20with%20cute%20bear%20characters%2C%20bright%20and%20warm%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-109&orientation=portrait",
    },
    {
      id: 110, title: "唐探1900", year: 2025, category: "悬疑 / 喜剧", rating: 8.3, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20comedy%20film%20poster%20with%20detective%20theme%2C%20warm%20vintage%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-110&orientation=portrait",
      tags: ["新片"],
    },
    {
      id: 111, title: "哥斯拉大战金刚2", year: 2025, category: "动作 / 科幻", rating: 8.0, region: "美国",
      imageUrl: "https://readdy.ai/api/search-image?query=Hollywood%20monster%20action%20film%20poster%20with%20giant%20creatures%20battling%2C%20epic%20scale%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-111&orientation=portrait",
    },
    {
      id: 112, title: "飞驰人生2", year: 2025, category: "喜剧 / 运动", rating: 8.3, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20film%20poster%20with%20cars%20on%20track%2C%20dynamic%20action%2C%20warm%20sunlight%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-movie-112&orientation=portrait",
    },
  ],
  tv: [
    {
      id: 201, title: "庆余年第二季", year: 2025, category: "古装 / 权谋", rating: 8.8, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20ancient%20palace%20setting%2C%20elegant%20characters%2C%20warm%20golden%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-201&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 202, title: "与凤行", year: 2025, category: "仙侠 / 爱情", rating: 8.4, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20ethereal%20characters%2C%20soft%20pink%20and%20gold%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-202&orientation=portrait",
    },
    {
      id: 203, title: "狂飙", year: 2024, category: "犯罪 / 剧情", rating: 9.1, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20intense%20portraits%2C%20dark%20urban%20setting%2C%20dramatic%20warm%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-203&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 204, title: "去有风的地方", year: 2024, category: "治愈 / 爱情", rating: 8.5, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20healing%20romance%20drama%20poster%20with%20beautiful%20rural%20landscape%2C%20warm%20sunlight%2C%20gentle%20peaceful%20atmosphere%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-204&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 205, title: "三体", year: 2024, category: "科幻 / 悬疑", rating: 8.7, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20and%20mysterious%20atmosphere%2C%20deep%20space%2C%20blue%20and%20gold%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-205&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 206, title: "繁花", year: 2024, category: "剧情 / 年代", rating: 8.6, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20with%201990s%20Shanghai%20style%2C%20nostalgic%20golden%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-206&orientation=portrait",
    },
    {
      id: 207, title: "长相思", year: 2024, category: "仙侠 / 爱情", rating: 8.3, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20ancient%20beauty%20and%20flowing%20sleeves%2C%20soft%20warm%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-207&orientation=portrait",
    },
    {
      id: 208, title: "莲花楼", year: 2023, category: "武侠 / 悬疑", rating: 8.8, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20drama%20poster%20with%20swordsman%2C%20ancient%20Chinese%20aesthetic%2C%20warm%20earthy%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-tv-208&orientation=portrait",
      tags: ["高分"],
    },
  ],
  anime: [
    {
      id: 301, title: "间谍过家家", year: 2025, category: "动画 / 喜剧", rating: 8.9, region: "日本",
      imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20comedy%20poster%20with%20stylish%20characters%2C%20warm%20bright%20colors%2C%20anime%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-anime-301&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 302, title: "鬼灭之刃 柱训练篇", year: 2025, category: "动画 / 热血", rating: 8.7, region: "日本",
      imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20action%20poster%20with%20dynamic%20sword%20fight%2C%20vibrant%20red%20and%20dark%20tones%2C%20anime%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-anime-302&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 303, title: "咒术回战 第二季", year: 2024, category: "动画 / 战斗", rating: 9.0, region: "日本",
      imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20jujutsu%20sorcery%20battle%20poster%20with%20dynamic%20characters%2C%20dark%20and%20warm%20energy%20effects%2C%20anime%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-anime-303&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 304, title: "葬送的芙莉莲", year: 2024, category: "动画 / 奇幻", rating: 9.3, region: "日本",
      imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20fantasy%20adventure%20poster%20with%20elf%20mage%20in%20beautiful%20landscape%2C%20soft%20warm%20sunlight%2C%20anime%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-anime-304&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 305, title: "进击的巨人 完结篇", year: 2024, category: "动画 / 战斗", rating: 9.1, region: "日本",
      imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20attack%20on%20titan%20epic%20poster%20with%20giant%20titans%20and%20soldiers%2C%20dramatic%20warm%20lighting%2C%20anime%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-anime-305&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 306, title: "拾荒者统治", year: 2024, category: "动画 / 科幻", rating: 8.5, region: "美国",
      imageUrl: "https://readdy.ai/api/search-image?query=Western%20animated%20sci-fi%20series%20poster%20with%20alien%20planet%20landscape%2C%20surreal%20warm%20colors%2C%20animation%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-anime-306&orientation=portrait",
    },
  ],
  variety: [
    {
      id: 401, title: "乘风破浪的姐姐", year: 2025, category: "综艺 / 竞技", rating: 8.6, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20female%20celebrities%20on%20stage%2C%20glamorous%20lighting%2C%20warm%20golden%20tones%2C%20entertainment%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-variety-401&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 402, title: "奔跑吧第12季", year: 2025, category: "综艺 / 户外", rating: 8.2, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%20with%20celebrities%20running%2C%20bright%20sunny%20day%2C%20warm%20energetic%20tones%2C%20entertainment%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-variety-402&orientation=portrait",
    },
    {
      id: 403, title: "歌手2025", year: 2025, category: "综艺 / 音乐", rating: 8.8, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%20with%20singer%20on%20stage%2C%20dramatic%20spotlight%2C%20warm%20golden%20tones%2C%20entertainment%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-variety-403&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 404, title: "令人心动的offer", year: 2025, category: "综艺 / 职场", rating: 8.4, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20career%20reality%20show%20poster%20with%20young%20professionals%2C%20modern%20office%20setting%2C%20warm%20professional%20tones%2C%20entertainment%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-variety-404&orientation=portrait",
    },
  ],
  documentary: [
    {
      id: 501, title: "地球脉动3", year: 2025, category: "纪录片 / 自然", rating: 9.6, region: "英国",
      imageUrl: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20landscapes%2C%20warm%20natural%20lighting%2C%20cinematic%20style%2C%20documentary%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-doc-501&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 502, title: "舌尖上的中国4", year: 2025, category: "纪录片 / 美食", rating: 9.2, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20cuisine%2C%20warm%20steaming%20atmosphere%2C%20appetizing%20golden%20tones%2C%20documentary%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-doc-502&orientation=portrait",
      tags: ["热门"],
    },
    {
      id: 503, title: "蓝色星球3", year: 2024, category: "纪录片 / 海洋", rating: 9.5, region: "英国",
      imageUrl: "https://readdy.ai/api/search-image?query=Ocean%20documentary%20poster%20with%20underwater%20marine%20life%2C%20deep%20blue%20and%20warm%20sunlight%20rays%2C%20cinematic%20style%2C%20documentary%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-doc-503&orientation=portrait",
      tags: ["高分"],
    },
    {
      id: 504, title: "河西走廊", year: 2023, category: "纪录片 / 历史", rating: 9.3, region: "中国大陆",
      imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20documentary%20poster%20with%20ancient%20silk%20road%20landscape%2C%20golden%20desert%20tones%2C%20cinematic%20style%2C%20documentary%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=cat-doc-504&orientation=portrait",
    },
  ],
};

export const categoryInfo: Record<string, { name: string; description: string; icon: string }> = {
  movie: {
    name: "电影",
    description: "被窝网电影大全收录海量高清电影资源，涵盖动作、喜剧、科幻、爱情、恐怖、悬疑等全类型，每日更新最新院线大片与经典佳片，满足各类影迷的观影需求。",
    icon: "ri-movie-2-line",
  },
  tv: {
    name: "电视剧",
    description: "被窝网电视剧频道汇集热门国产剧、韩剧、美剧、日剧，提供全集在线观看，高清流畅不缓冲，追剧党必备的免费电视剧平台。",
    icon: "ri-tv-2-line",
  },
  anime: {
    name: "动漫",
    description: "被窝网动漫频道聚合日漫、国漫、美漫等优质动画资源，无论是热血战斗、治愈日常还是悬疑推理，这里都有你想看的动漫作品。",
    icon: "ri-ghost-smile-line",
  },
  variety: {
    name: "综艺",
    description: "被窝网综艺频道提供热门综艺节目在线观看，包含音乐竞演、户外真人秀、脱口秀、职场观察等多元化内容，让你笑料不断。",
    icon: "ri-live-line",
  },
  documentary: {
    name: "纪录片",
    description: "被窝网纪录片频道精选全球高分纪录片，涵盖自然、历史、美食、科技等主题，带你用镜头探索世界的奥秘与精彩。",
    icon: "ri-film-line",
  },
};

export const detailMovies: Record<number, {
  id: number;
  title: string;
  year: number;
  category: string;
  rating: number;
  region: string;
  director: string;
  cast: string;
  description: string;
  imageUrl: string;
  posterUrl: string;
  tags: string[];
  relatedIds: number[];
}> = {
  1: {
    id: 1, title: "流浪地球3", year: 2026, category: "科幻 / 冒险", rating: 9.2, region: "中国大陆",
    director: "郭帆", cast: "吴京 / 刘德华 / 李雪健 / 沙溢 / 宁理",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。本片是中国科幻电影的里程碑之作，视觉效果震撼，情感真挚动人，被誉为国产科幻的新高度。",
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20science%20fiction%20movie%20banner%20with%20giant%20planet%20engines%20and%20futuristic%20space%2C%20warm%20orange%20atmospheric%20lighting%2C%20cinematic%20ultra%20wide%2C%20grand%20scale%2C%20dramatic%20composition&width=1200&height=600&seq=detail-1-hero&orientation=landscape",
    posterUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20science%20fiction%20movie%20poster%20with%20futuristic%20space%20station%2C%20warm%20orange%20lighting%2C%20cinematic%20style%2C%20dramatic%20atmosphere%2C%20movie%20poster%20design%2C%20clean%20background&width=600&height=800&seq=detail-poster-1&orientation=portrait",
    tags: ["热门", "高分", "新片"], relatedIds: [2, 3, 7, 4],
  },
  2: {
    id: 2, title: "封神第二部", year: 2026, category: "奇幻 / 动作", rating: 8.9, region: "中国大陆",
    director: "乌尔善", cast: "费翔 / 李雪健 / 黄渤 / 于适 / 陈牧驰",
    description: "殷商大军兵临西岐，姜子牙与姬发率领西岐军民奋起反抗。一场关乎天下苍生命运的大战即将展开。影片延续第一部的史诗气质，特效场面全面升级，神仙斗法的视觉呈现令人叹为观止，将中国神话史诗电影推向新高度。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20banner%20with%20ancient%20battle%20and%20mythical%20beasts%2C%20golden%20and%20crimson%20atmospheric%20tones%2C%20cinematic%20ultra%20wide%2C%20grand%20scale&width=1200&height=600&seq=detail-2-hero&orientation=landscape",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%2C%20golden%20and%20red%20tones%2C%20cinematic%20style%2C%20dramatic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=detail-poster-2&orientation=portrait",
    tags: ["热门", "新片"], relatedIds: [1, 3, 8, 5],
  },
  3: {
    id: 3, title: "哪吒之魔童闹海", year: 2025, category: "动画 / 奇幻", rating: 9.5, region: "中国大陆",
    director: "饺子", cast: "吕艳婷 / 陈浩 / 囧森瑟夫",
    description: "天劫之后，哪吒和敖丙的灵魂虽得以保留，但肉身即将魂飞魄散。太乙真人打算用七色宝莲为二人重塑肉身，然而在重塑肉身的过程中却遇到了重重困难。哪吒与敖丙将面临新的命运抉择，一场更大的危机正在酝酿。",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20banner%20with%20mythological%20hero%20and%20dragon%2C%20vibrant%20red%20and%20gold%20atmospheric%20effects%2C%20cinematic%20ultra%20wide%2C%20dynamic%20composition&width=1200&height=600&seq=detail-3-hero&orientation=landscape",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20mythological%20hero%20character%2C%20vibrant%20red%20tones%2C%20dynamic%20pose%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20background&width=600&height=800&seq=detail-poster-3&orientation=portrait",
    tags: ["高分", "热门"], relatedIds: [1, 2, 11, 7],
  },
  4: {
    id: 4, title: "奥本海默", year: 2023, category: "剧情 / 传记", rating: 8.8, region: "美国",
    director: "克里斯托弗·诺兰", cast: "基里安·墨菲 / 艾米莉·布朗特 / 马特·达蒙 / 小罗伯特·唐尼",
    description: "聚焦美国「原子弹之父」罗伯特·奥本海默的故事。影片讲述了这位杰出的物理学家领导曼哈顿计划，成功研制出世界上第一颗原子弹的过程，以及随后他面临的政治迫害和道德困境。诺兰以他标志性的非线性叙事，呈现了这场改变人类历史的科学壮举背后的复杂人性。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20biographical%20film%20banner%20with%20atomic%20explosion%20and%20intense%20portrait%2C%20dark%20warm%20atmospheric%20lighting%2C%20cinematic%20ultra%20wide%2C%20dramatic%20composition&width=1200&height=600&seq=detail-4-hero&orientation=landscape",
    posterUrl: "https://readdy.ai/api/search-image?query=Dramatic%20biographical%20film%20poster%20with%20intense%20portrait%20and%20atomic%20motif%2C%20dark%20and%20warm%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=detail-poster-4&orientation=portrait",
    tags: ["高分", "经典"], relatedIds: [7, 1, 13, 5],
  },
};